<!-- A plain div, not <label>: wrapping an interactive <button> in a <label> makes the
     browser auto-forward clicks to the button as a "labelable control", and once the
     checkmark SVG renders inside the button (after the first toggle), a click landing on
     that SVG can get double-dispatched (bubbled click + the label's synthetic forward) -
     toggle() then fires twice, netting no visible change. One click handler on the
     wrapper, none on the button, sidesteps that entirely regardless of what's clicked. -->
<div
  class="gpd-checkbox-wrapper"
  [class.gpd-checkbox-wrapper--disabled]="disabled"
  (click)="toggle()"
>
  <button type="button" class="gpd-checkbox" [class.gpd-checkbox--checked]="value" [attr.aria-pressed]="value" [disabled]="disabled">
    <svg
      *ngIf="value"
      class="gpd-checkbox-mark"
      viewBox="0 0 10.9453 8.09766"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9453 1.06641L3.97266 8.09766L0 4.06641L1.05469 3L3.97266 5.84766L9.89062 0L10.9453 1.06641Z"
        fill="var(--color-primary)"
      />
    </svg>
  </button>
  <span *ngIf="label" class="gpd-checkbox-label">{{ label }}</span>
</div>
